import { Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Shimmer } from '@component/new_shimmer.component';

export const Skeleton = () => {
	return (
		<Flex gap={tokens.spacing.x3} grow='1'>
			<Shimmer height={40} width='50%' />

			<Flex gap={tokens.spacing.x0_5}>
				<Shimmer height={15} width='30%' />
				<Shimmer height={15} width='80%' />
				<Shimmer height={15} width='60%' />
				<Shimmer height={15} width='70%' />
			</Flex>
		</Flex>
	);
};
